import { SearchParams } from 'api/types'

export const urlFor = (
  pathname: string,
  searchParams: SearchParams,
  key: string,
  value: string | undefined
): string => {
  const urlSearchParams = new URLSearchParams(
    searchParams as Record<string, string>
  )

  // always remove `page`, all filter changes reset pagination
  urlSearchParams.delete('page')

  // remove key for `undefined` value, or set it
  if (value === undefined) {
    urlSearchParams.delete(key)
  } else {
    urlSearchParams.set(key, value)
  }

  // ensure the url is always the same order/stucture for best possible http caching
  const sortedSearchParams = new URLSearchParams(
    Array.from(urlSearchParams.entries()).sort((a, b) =>
      a[0].localeCompare(b[0])
    )
  )

  return `${pathname}?${sortedSearchParams.toString()}`
}
